import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'config/axiosBaseQuery';
import { endpoints } from 'config/api';
import {
  ChatMessagesResponse,
  ChatMessagesQueryParams,
  ChatUnreadCountResponse,
} from './projectChatTypes';

export const projectChatApi = createApi({
  reducerPath: 'projectChatApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['ProjectChatMessages'],
  endpoints: (builder) => ({
    getChatMessages: builder.query<
      ChatMessagesResponse,
      { projectId: string; params?: ChatMessagesQueryParams }
    >({
      query: ({ projectId, params }) => {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append('page', params.page.toString());
        if (params?.limit) queryParams.append('limit', params.limit.toString());
        if (params?.before) queryParams.append('before', params.before);

        const queryString = queryParams.toString();
        return {
          url: `${endpoints.projects.chatMessages(projectId)}${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
        };
      },
      providesTags: (_result, _error, { projectId }) => [
        { type: 'ProjectChatMessages', id: projectId },
      ],
    }),

    getChatUnreadCount: builder.query<ChatUnreadCountResponse, string>({
      query: (projectId) => ({
        url: endpoints.projects.chatUnreadCount(projectId),
        method: 'GET',
      }),
    }),

    deleteChatMessage: builder.mutation<
      { success: boolean; message: string },
      { projectId: string; messageId: string }
    >({
      query: ({ projectId, messageId }) => ({
        url: endpoints.projects.chatDeleteMessage(projectId, messageId),
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, { projectId }) => [
        { type: 'ProjectChatMessages', id: projectId },
      ],
    }),
  }),
});

export const {
  useGetChatMessagesQuery,
  useLazyGetChatMessagesQuery,
  useGetChatUnreadCountQuery,
  useDeleteChatMessageMutation,
} = projectChatApi;

